declare module "is-ua-webview";
